import type { SVGProps } from 'react';

const SvgJobs = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M10 21.05a.983.983 0 0 1-.99-1.14l.79-5.53-2.56.64c-.36.09-.74-.03-.99-.3-.25-.28-.32-.67-.19-1.02l3-8c.11-.3.36-.52.66-.61l7.01-2c.38-.11.79.02 1.04.32.25.31.3.73.12 1.09l-2.03 4.06 1.89-.47c.41-.1.84.06 1.07.41.24.35.23.81-.02 1.15l-8 11c-.19.26-.5.41-.81.41zm1-9c.24 0 .48.09.67.26.25.22.37.55.32.88l-.43 3.01 4.01-5.52-1.33.33c-.38.09-.78-.04-1.02-.34a.99.99 0 0 1-.11-1.07l1.98-3.97-4.33 1.24-2.15 5.74 2.15-.54q.12-.03.24-.03z"
    />
  </svg>
);
export default SvgJobs;
